import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RSVP.css';

const RSVP = () => {
  const navigate = useNavigate();

  const handleDetailsClick = () => {
    navigate('/events/be-our-witness/form');
  };

  return (
    <section id="rsvp" className="rsvp-section">
      <div className="rsvp-container">
        <div className="rsvp-content">
          <p className="rsvp-countdown">0 DAYS TO THE EVENT</p>
          <h2 className="rsvp-title">Be Our<br/>Witness</h2>
          <div className="rsvp-text">
            <p>Please Respond By 24th April, 2023</p>
            <p>Please contact us directly if you need vegetarian menu options</p>
          </div>
          <button className="rsvp-button" onClick={handleDetailsClick}>Details</button>
        </div>
        <div className="rsvp-image"></div>
      </div>
    </section>
  );
};

export default RSVP;

